<template>
  <div class="pt-1">
    <v-card>
      <v-card-title class="pb-0 mx-auto">
        <v-card-text class="pa-0">
          <p class="text-xs-center">
            {{ data.nombre }}
          </p>
        </v-card-text>
      </v-card-title>

      <v-card-text>
        <p class="caption">
          Adultos {{ data.tarifas.totales["@attributes"].adl }}
          <span v-if="data.tarifas.totales['@attributes'].chd != 0"
            >Menores {{ data.tarifas.totales["@attributes"].chd }}</span
          >
          <span class="float-right">
            {{ data.tarifas.totales.moneda }} {{ data.tarifas.totales.venta }}
            <span v-if="editable">
              <v-icon class="caption mb-1 cur-pointer" color="red" @click="borrarPase(data.unico_carrito)"
                >fas fa-trash-alt</v-icon
              >
            </span>
          </span>
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "carritoPanelPase",
  props: ["data"],
  components: {},
  mounted() {},
  created() {},
  methods: {
    borrarPase(unico_carrito) {
      this.$store.dispatch("carrito/borrarPase", unico_carrito)
    }
  },
  computed: {
    editable: function() {
      switch (this.$route.name) {
        case "pasajerosCupoAgencias":
        case "facturacion":
          return false
          break

        default:
          return true
          break
      }
    }
  }
}
</script>
<style scoped>
.hover-hab-as:hover {
  background-color: #eceff1;
}
</style>
